import * as EditorHelpers from './EditorHelpers';

export function getLeftRightWidthFromPosAndValues(pos, lv, wv, rv, insetWidth, insetHeight){

  function getLocFromDimensions(t, v, changeWhat){
    return EditorHelpers.reverseScale(v, t, changeWhat, insetWidth, insetHeight);
  }

  var s = {};
  if (pos.lr.v === 0 || pos.lr.v === 1){
    s.left = getLocFromDimensions(pos.l.t, lv, 'l');
  }
  if (pos.lr.v === 0 || pos.lr.v === 2){
    s.width = getLocFromDimensions(pos.w.t, wv, 'w');
  }
  if (pos.lr.v === 1 || pos.lr.v === 2){
    s.right = getLocFromDimensions(pos.r.t, rv, 'r');
  }

  if (pos.lr.v === 1){ //this is needed for picture mode as we need to specify width.
    s.width = insetWidth - s.left - s.right;
  }
  return s;

}
